export const EnumAuthProvider = {
  SVGIO: 'SVGIO',
  GOOGLE: 'GOOGLE',
  FACEBOOK: 'FACEBOOK',
} as const

export const EnumEmailTemplate = {
  VERIFY_EMAIL: 'VERIFY_EMAIL',
  WELCOME: 'WELCOME',
  RESET_PASSWORD: 'RESET_PASSWORD',
  RESET_PASSWORD_SUCCESSFUL: 'RESET_PASSWORD_SUCCESSFUL',
  DELETE_ACCOUNT: 'DELETE_ACCOUNT',
  SUBSCRIPTION_CHANGED_FREE_TO_PAID: 'SUBSCRIPTION_CHANGED_FREE_TO_PAID',
  SUBSCRIPTION_CHANGED_PAID_TO_FREE: 'SUBSCRIPTION_CHANGED_PAID_TO_FREE',
  SUBSCRIPTION_CHANGED_PAID_TO_PAID_UPGRADE: 'SUBSCRIPTION_CHANGED_PAID_TO_PAID_UPGRADE',
  SUBSCRIPTION_CHANGED_PAID_TO_PAID_DOWNGRADE: 'SUBSCRIPTION_CHANGED_PAID_TO_PAID_DOWNGRADE',
  SUBSCRIPTION_CHANGED_PAID_TO_PAID_BILLING_PERIOD_CHANGED: 'SUBSCRIPTION_CHANGED_PAID_TO_PAID_BILLING_PERIOD_CHANGED',
  SUBSCRIPTION_RENEWED: 'SUBSCRIPTION_RENEWED',
} as const

export const EnumGender = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
} as const

export const EnumMembershipPeriod = {
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',
} as const

export const EnumMembershipType = {
  LITE: 'LITE',
  PRO: 'PRO',
  PREMIUM: 'PREMIUM',
} as const

export const EnumPurchaseType = {
  MEMBERSHIP: 'MEMBERSHIP',
  CREDITS: 'CREDITS',
} as const

export const EnumStyle = {
  FLAT_VECTOR: 'FLAT_VECTOR',
  FLAT_VECTOR_ONE_LINE_ART: 'FLAT_VECTOR_ONE_LINE_ART',
  FLAT_VECTOR_OUTLINE: 'FLAT_VECTOR_OUTLINE',
  FLAT_VECTOR_LINE_ART: 'FLAT_VECTOR_LINE_ART',
  FLAT_VECTOR_SILHOUETTE: 'FLAT_VECTOR_SILHOUETTE',
} as const

export const EnumVerifyType = {
  VERIFY_EMAIL: 'VERIFY_EMAIL',
  RESET_PASSWORD: 'RESET_PASSWORD',
} as const
